import { useState } from 'react';
import { Send } from 'lucide-react';
import { useStore } from '@/shared/state/store';

export function CommentInput({
  target,
  targetId,
}: {
  target: 'post' | 'reel';
  targetId: string;
}) {
  const [text, setText] = useState('');
  const addComment = useStore((s) => s.addComment);
  const submit = () => {
    const t = text.trim();
    if (!t) return;
    addComment({ target, targetId, text: t });
    setText('');
  };
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
      className="fixed bottom-20 left-1/2 -translate-x-1/2 w-full max-w-md px-4 z-30"
    >
      <div className="glass-strong rounded-full flex items-center gap-2 px-4 py-2.5">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Add a comment…"
          className="bg-transparent flex-1 outline-none text-sm text-white/90 placeholder:text-white/40"
        />
        <button
          type="submit"
          disabled={!text.trim()}
          aria-label="Post comment"
          className="text-rose-300 disabled:text-white/20 active:scale-90 transition-transform"
        >
          <Send className="w-4 h-4" />
        </button>
      </div>
    </form>
  );
}
